import React from 'react';
import { Tooltip } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { LARGE_TOOLTIP_SLOT_PROPS } from '../../../../../common/styles/tooltip';

// the text in the viewer's native language on hover (tap on touch); no tooltip until it's there
export const NativeTooltip: React.FC<{ text?: string, children: React.ReactElement }> = ({ text, children }) => (
	text
		? <Tooltip
			title={text}
			enterTouchDelay={0}
			leaveTouchDelay={4000}
			enterDelay={500}
			enterNextDelay={500}
			placement={'top-start'}
			slotProps={{
				...LARGE_TOOLTIP_SLOT_PROPS,
				tooltip: { sx: {
					...LARGE_TOOLTIP_SLOT_PROPS.tooltip.sx,
					p: theme.spacing(1),
					lineHeight: 1.2,
				},
			}}}
		>
			{children}
		</Tooltip>
		: children
);
